export interface TokenResponse {
  token?: string;
  refreshToken?: string;
}

export function isTokenResponse(value: unknown): value is TokenResponse {
  return value !== undefined && typeof value === 'object' && value !== null;
}
